import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Brittany Murphy was really hawt",
  "description": "",
  "published": "2009-12-21T00:00:00.000Z",
  "redirect_from": ["/blog/brittany-murphy-was-really-hawt/swizec/1015"],
  "categories": "Brittany Murphy, Conspiracy theory, food for thought, Health, HeathLedger, intrigues, James Dean, Jim Morrison, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Brittanymurphynavy.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/300px-Brittanymurphynavy.jpg",
              "alt": "Brittany Murphy",
              "title": "Brittany Murphy"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Brittanymurphynavy.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`There is something specially tragic about sexy people leaving this world. There was a big humbug when `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/James_Dean",
        "title": "James Dean"
      }}>{`James Dean`}</a>{` died, there was an outrage `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Jim_Morrison",
        "title": "Jim Morrison"
      }}>{`Jim Morrison`}</a>{` died, there was an uproar when Hendrix passed and there was a whole lot of baawwing all over the interwebs when mr. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Heath_Ledger",
        "title": "Heath Ledger"
      }}>{`Heath Ledger`}</a>{` died last year and today we've lost another downright sexy person - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Brittany_Murphy",
        "title": "Brittany Murphy"
      }}>{`Brittany Murphy`}</a>{`.`}</p>
    <p>{`She isn't likely to reach such instant extents of fame and notoriety and legendary proportions of personality as the rest of them did ... probably because she's a woman or perhaps just because she wasn't quite as famous ... but she was nontheless incredibly sexy and gorgeous and by god I wish she did some porn.`}</p>
    <p>{`I must admit I have no idea why we take such big notice when beautiful people die - perhaps it's just our internal reaction to feeling the sexiness of the world slipping between our fingers. We `}<em parentName="p">{`want`}</em>{` the world to be a sexy place and we so rarely contribute anything to the amount of sexy out there that it just strikes us very intimately, very personally, when the sexy is reduced.`}</p>
    <p>{`They also all seem to go in such dubious circumstances, I'd go in more detail but I couldn't do it much justice because I'm not a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Conspiracy_theory",
        "title": "Conspiracy theory"
      }}>{`conspiracy theorist`}</a>{` at heart ... certainly someone else can do a better job. Why do `}<strong parentName="p">{`you`}</strong>{` think they all go so very young and under such strange circumstances?`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Jim_Morrison_-_Fillmore_East.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Jim_Morrison_-_Fillmore_East.jpg",
              "alt": "Jim Morrison at The Fillmore East in New York,...",
              "title": "Jim Morrison at The Fillmore East in New York,..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Jim_Morrison_-_Fillmore_East.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:James_Dean_in_East_of_Eden_trailer_2.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/300px-James_Dean_in_East_of_Eden_trailer_2.jpg",
              "alt": "as Cal Trask in East of Eden (1955)",
              "title": "as Cal Trask in East of Eden (1955)"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:James_Dean_in_East_of_Eden_trailer_2.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Jimmy_Hendrix.JPG"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Jimmy_Hendrix.JPG",
              "alt": "\"Jimi Hendrix\"",
              "title": "\"Jimi Hendrix\""
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Jimmy_Hendrix.JPG"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Heath_Ledger.jpg"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2009/12/300px-Heath_Ledger.jpg",
              "alt": "Ledger at the 2006 Berlin International Film F...",
              "title": "Ledger at the 2006 Berlin International Film F..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://commons.wikipedia.org/wiki/Image:Heath_Ledger.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://userserve-ak.last.fm/serve/126/2924237.jpg"
      }}></a></p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/2dbcdf9e-9eba-42a8-bc71-11b66b68b73e/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=2dbcdf9e-9eba-42a8-bc71-11b66b68b73e",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      